import { render, staticRenderFns } from "./ResultAnswer.vue?vue&type=template&id=5a81a96a&lang=pug&"
import script from "./ResultAnswer.vue?vue&type=script&lang=ts&"
export * from "./ResultAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports